import "./AboutTexts.css";

export default function AboutTexts({ paragraphs }) {
  return (
    <div className="about-preview__texts">
      {paragraphs.map((text, index) => (
        <p
          key={index}
          className={`reveal-on-scroll reveal-on-scroll--up reveal-delay-${
            (index % 3) + 2
          }`}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      ))}
    </div>
  );
}